import React, {Component, Fragment} from 'react';
import './OitProgressBar.scss';
import classNames from 'classnames';
import DisplayUserPhoto from "../../subscriber-app/components/users/DisplayUserPhoto";
import TimeChart from "../../subscriber-app/components/analytics/TimeChart";

function getOpenedPhase({trainingPhases}) {
  return trainingPhases ? trainingPhases.find(trainingPhase => trainingPhase.status === 'opened'): null;
}

function areItemsTheSame(nextItems, prevItems) {
  if(nextItems.length === prevItems.length) {
    return nextItems.filter((item, index) => item.guid === prevItems[index].guid).length === prevItems.length;
  } else {
    return false;
  }
}

const phaseOrder = ['completed', 'opened', 'pending'];

const getHours = (timeSegments) => {
  return timeSegments && timeSegments.find(ts => ts.segment === 'total') || {total: 0, average: 0}
}

class OitProgressBar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedPhases: this.initSelectedPhases(props.items)
    };
    props.canViewTrainingProgramDetails
    && props.onLoadReportsForTP
    && props.onLoadReportsForTP(this.initSelectedPhases(props.items))
  }

  componentWillReceiveProps(nextProps) {
    if(!areItemsTheSame(nextProps.items, this.props.items)) {
      this.setState({
        selectedPhases: this.initSelectedPhases(nextProps.items)
      });
      this.props.canViewTrainingProgramDetails
      && this.props.onLoadReportsForTP
      && this.props.onLoadReportsForTP(this.initSelectedPhases(nextProps.items))
    }
  }

  initSelectedPhases(items) {
    let selectedItems = {};
    items.forEach(oit => {
      let openedTP = oit.trainingPhases.find(tp => tp.status === 'opened');
      if(openedTP) {
        selectedItems[oit.guid] = openedTP;
      } else {
        selectedItems[oit.guid] = oit.trainingPhases[oit.trainingPhases.length - 1];
      }
    });

    return selectedItems;
  }

  selectTrainingPhase(tp, oit) {
    if(this.isPhaseSelectible(tp, oit)) {
      this.setState({
        selectedPhases: {
          ...this.state.selectedPhases,
          [oit.guid]: tp
        }
      });

      this.props.onLoadReportsForTP && this.props.onLoadReportsForTP( {
        [oit.guid]: tp
      })

    }
  }

  isPhaseSelectible(tp, oit) {
    return this.props.canViewTrainingProgramDetails
      && (tp.status === 'opened' || tp.status === 'completed')
      && this.state.selectedPhases[oit.guid].trainingPhaseGuid !== tp.trainingPhaseGuid;
  }

  isPhaseSelected(tp, oit) {
    return this.props.canViewTrainingProgramDetails
      && this.state.selectedPhases[oit.guid].trainingPhaseGuid === tp.trainingPhaseGuid;
  }

  getSelectedPhase(oit) {
    return this.state.selectedPhases[oit.guid];
  }

  orderedPhases(trainingPhases) {
    return trainingPhases.sort(function compare(a, b) {
      return phaseOrder.indexOf(a.status) - phaseOrder.indexOf(b.status)
    })
  }

  hasHoursSetup(traningPhases) {
    return !!traningPhases.find(tp => tp.hours)
  }


  render() {
    let {items, onViewDetails, onViewOpenForms, tickValues, barColor, hideTopAxis} = this.props;

    return (
      <div className="bar-chart">
        { !hideTopAxis &&
        <div className="bar-chart-axis">
          { tickValues.map(tick => (
            <div className="axis-tick" key={tick.toString()}>
              <div className="text">{tick}</div>
            </div>
          ))}
        </div>
        }

        { items.map((item) => (
          <Fragment key={item.guid}>
            {/*<div className="actions">*/}
            {/*<div className="action button default small" onClick={() => onViewDetails(item)}>*/}
            {/*<i className="fa fa-user"/>*/}
            {/*<span>View details</span>*/}
            {/*</div>*/}
            {/*</div>*/}
            {item.endsAt && item.status !== 'paused' && (
              <div style={{textAlign: 'right', marginTop: this.hasHoursSetup(item.trainingPhases)? '20px':''}}>PROJECTED training end: {item.endsAt.format('MM/DD/YYYY')}</div>
            )}
            <div className={classNames("horizontal-bar",  {timebased: this.hasHoursSetup(item.trainingPhases)})} onClick={() => onViewDetails(item)}>
              <div
                className="progress"
                style={{transform: `translateX(-${100 - item.x}%)`, backgroundColor: barColor && barColor(item)}}/>
              <div className="text">
                {item.photo && <DisplayUserPhoto
                  user={item}
                />}
                <span className="name-holder">{item.y}</span>
                {item.notStarted ? (
                  <span className="align-center"><b>Not started</b></span>
                ) : item.status === 'terminated'
                  ? (
                    <span className="align-center"><b>Terminated</b></span>
                  ) : item.status === 'paused'
                  ? (
                    <span className="align-center"><b>Paused</b></span>
                  ) : item.status === 'resigned' ? (
                    <span className="align-center"><b>Resigned</b></span>
                  ) : item.status === 'paused'? (
                      <span className="align-center"><b>Paused</b></span>
                    )
                    : <span className="align-center"><b>{item.x}%</b></span>}

              </div>
            </div>
            <div className="phases-time">
              {this.orderedPhases(item.trainingPhases).map(tp => (
                <TimeChart
                  key={'time-chart' + tp.trainingPhaseGuid}
                  phase={tp}
                  hours={getHours(tp.time_segments).total}
                  compact={true}
                />
              ))}
            </div>
            {!this.hasHoursSetup(item.trainingPhases) && <div className="phases">
              {this.orderedPhases(item.trainingPhases).map(tp => (
                <div
                  className={classNames('phase', tp.status, {
                    selected: this.isPhaseSelected(tp, item),
                    selectable: this.isPhaseSelectible(tp, item)
                  })}
                  key={tp.trainingPhaseGuid}
                  onClick={() => this.selectTrainingPhase(tp, item)}
                >
                  {tp.header}
                </div>
              ))}
            </div>}
          </Fragment>

        ))}
        <div className="bar-chart-axis position-bottom">
          {tickValues.map(tick => (
            <div className="axis-tick" key={tick.toString()}>
              <div className="text">{tick}</div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default OitProgressBar;
